const palettes = [
    [[91, 146, 229], [255, 184, 28]],

    [[91, 146, 229], [255, 103, 31], [255, 184, 28], [92, 184, 178]],

    [[91, 146, 229], [210, 38, 48], [255, 103, 31], [255, 184, 28], [92, 184, 178]],

    [[91, 146, 229], [0, 51, 160], [152, 54, 178], [210, 38, 48], [255, 103, 31], [255, 184, 28],
        [205, 220, 58], [92, 184, 178]],

    [[1, 188, 214], [46, 190, 255], [91, 146, 229], [0, 51, 160], [104, 58, 183], [152, 54, 178],
        [210, 15, 119], [210, 38, 48], [255, 103, 31], [255, 184, 28], [255, 236, 60], [205, 220, 58],
        [139, 195, 73], [36, 155, 35], [92, 184, 178]]
];

export const getColorPalette = function(amount, customPalettes = null){
    const selectedPalettes = (customPalettes === null) ? palettes : customPalettes;
    let index = 0;
    for(const palette of selectedPalettes){
        index++;
        if(palette.length < amount && index < selectedPalettes.length){
            continue;
        }

        const step = palette.length / amount;
        let offset = 0;
        const result = [];
        for(let i = 0; i < amount; i++){
            const position = i * step + offset;
            const s = Math.floor(position);
            let f = position - s;
            offset = 0;

            // if close enough to palette colour 'snap' to it.
            if(step >= 1){
                f = Math.round(f);
            }else{
                if(f < 0.5 * step){
                    offset = -0.5 * f;
                    f = 0;
                }else if(1 - f < 0.5 * step){
                    offset = 0.5 * (1 - f);
                    f = 1;
                }
            }
            if(s + 1 >= palette.length){
                result.push([
                    palette[s][0],
                    palette[s][1],
                    palette[s][2]
                ]);
            }else{
                result.push([
                    Math.round((1 - f) * palette[s][0] + f * palette[s + 1][0]),
                    Math.round((1 - f) * palette[s][1] + f * palette[s + 1][1]),
                    Math.round((1 - f) * palette[s][2] + f * palette[s + 1][2])
                ]);
            }
        }
        return result;
    }
};

export const rgbToHsl = function(rgb){
    const r = rgb[0] / 255;
    const g = rgb[1] / 255;
    const b = rgb[2] / 255;

    const max = Math.max(r, g, b);
    const min = Math.min(r, g, b);
    let h; let s; const l = (max + min) / 2;

    if(max === min){
        h = s = 0; // achromatic
    }else{
        const d = max - min;
        s = l > 0.5 ? d / (2 - max - min) : d / (max + min);

        switch (max){
            case r: h = (g - b) / d + (g < b ? 6 : 0); break;
            case g: h = (b - r) / d + 2; break;
            case b: h = (r - g) / d + 4; break;
            default: break;
        }

        h /= 6;
    }

    return [360*h, 100*s, 100*l];
};

